import {
  DeleteOutlined,
  EditOutlined,
  EnvironmentOutlined,
  StarFilled,
} from "@ant-design/icons";
import { Button, Card, Space, Tag, Typography } from "antd";
import { motion } from "framer-motion";

import type { AccountAddress } from "@/types";
import { formatAccountAddress } from "@/utils/address";

const { Paragraph, Text } = Typography;

interface AccountAddressCardProps {
  address: AccountAddress;
  isDeleting?: boolean;
  isSettingDefault?: boolean;
  onDelete: (address: AccountAddress) => void;
  onEdit: (address: AccountAddress) => void;
  onSetDefault: (address: AccountAddress) => void;
}

export const AccountAddressCard = ({
  address,
  isDeleting = false,
  isSettingDefault = false,
  onDelete,
  onEdit,
  onSetDefault,
}: AccountAddressCardProps) => (
  <motion.div
    initial={{ opacity: 0, y: 16 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.22 }}
  >
    <Card className="account-address-card">
      <div className="account-address-card__body">
        <div className="account-address-card__main">
          <Space className="account-address-card__heading" size={[8, 8]} wrap>
            <Text strong>{address.name}</Text>
            <Text type="secondary">{address.phone}</Text>
            {address.email ? (
              <Text type="secondary">{address.email}</Text>
            ) : null}
            <Tag
              bordered={false}
              color={address.isDefault ? "gold" : undefined}
            >
              {address.isDefault ? "Mặc định" : "Địa chỉ nhận hàng"}
            </Tag>
          </Space>

          <Paragraph className="account-address-card__line" type="secondary">
            CCCD/Hộ chiếu: {address.citizenId}
          </Paragraph>

          <div className="account-address-card__location">
            <EnvironmentOutlined />
            <Text>{formatAccountAddress(address)}</Text>
          </div>
        </div>

        <Space className="account-address-card__actions" size={[8, 8]} wrap>
          {!address.isDefault ? (
            <Button
              icon={<StarFilled />}
              loading={isSettingDefault}
              onClick={() => onSetDefault(address)}
            >
              Đặt mặc định
            </Button>
          ) : null}
          <Button icon={<EditOutlined />} onClick={() => onEdit(address)}>
            Sửa
          </Button>
          <Button
            danger
            icon={<DeleteOutlined />}
            loading={isDeleting}
            onClick={() => onDelete(address)}
          >
            Xóa
          </Button>
        </Space>
      </div>
    </Card>
  </motion.div>
);
